<ng-container *transloco="let t">
    <span class="text-nowrap" container="body"
        [ngClass]="{'deleted-user': dataItem && dataItem['user'] && dataItem['user']['user_deleted_at']}"
        [ngbTooltip]="dataItem && dataItem['user'] && dataItem['user']['user_deleted_at'] ? t('Deleted user action label (general) - Deleted user') : ''"
        placement="top">
        {{dataItem && dataItem['user'] ? dataItem['user']['name']: ''}}
    </span>
</ng-container>